type CallBackType<T> = (...args: T[]) => void

export function debounce<T>(
  func: CallBackType<T>,
  delay: number,
): (...args: Parameters<CallBackType<T>>) => void {
  let timeoutId: ReturnType<typeof setTimeout> | undefined

  return (...args: Parameters<CallBackType<T>>) => {
    if (timeoutId) {
      clearTimeout(timeoutId)
    }

    timeoutId = setTimeout(() => {
      func(...args)
    }, delay)
  }
}
